export var ROUTES_NAMES;
(function (ROUTES_NAMES) {
    ROUTES_NAMES["ROOT"] = "/";
    ROUTES_NAMES["SOME_NAME"] = "/SOME_NAME";
})(ROUTES_NAMES || (ROUTES_NAMES = {}));
